import React, { useEffect, useState, useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";
import ElementPage from "../Elements";
import { getAlbumMediaByAlbumId } from "./MeldiDhamCRUD";
import { useTranslation } from "react-i18next";

const PhotoAndVideoListPage = () => {
  const [activeTab, setActiveTab] = useState("photo");
  const [albumMediaData, setAlbumMediaData] = useState([]);
  const [title, setTitle] = useState("");
  const [albumId, setAlbumId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showAlbum, setShowAlbum] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalItem, setModalItem] = useState(null);

  const location = useLocation();
  const pathUrl = process.env.REACT_APP_API_URL;
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const { state } = location;
    const albumTitle = state?.albumTitle || "Photos & Videos";
    const id = state?.albumId || 0;
    const mediaTypeId = state?.mediaTypeId;

    setAlbumId(id);
    setTitle(albumTitle);
    setActiveTab(mediaTypeId === 2 ? "video" : "photo");

    if (id) {
      setLoading(true);
      fetchAlbumMediaByAlbumId(id);
    }
  }, [location]);

  const fetchAlbumMediaByAlbumId = async (id) => {
    try {
      const res = await getAlbumMediaByAlbumId(id);
      if (res.data.isSuccess) {
        const activeMedia = res.data.responseObject.filter(
          (item) => item.isActive
        );
        setAlbumMediaData(activeMedia);
      }
    } catch (err) {
      console.error("Album media fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  const filteredData = useMemo(() => {
    return albumMediaData.filter((item) =>
      activeTab === "photo" ? item.mediaTypeID === 1 : item.mediaTypeID === 2
    );
  }, [albumMediaData, activeTab]);

  const handleTabChange = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setCurrentIndex(0);
      setModalItem(null);
      setShowAlbum(false);
    }
  };

  const handleShow_Album = (item) => {
    const index = filteredData.findIndex(
      (i) => i.albumMediaID === item.albumMediaID
    );
    setCurrentIndex(index);
    setModalItem(item);
    setShowAlbum(true);
  };

  const handleClose_Album = () => {
    setShowAlbum(false);
    setModalItem(null);
  };

  const handleNext = () => {
    const nextIndex = (currentIndex + 1) % filteredData.length;
    setCurrentIndex(nextIndex);
    setModalItem(filteredData[nextIndex]);
  };

  const handlePrev = () => {
    const prevIndex =
      (currentIndex - 1 + filteredData.length) % filteredData.length;
    setCurrentIndex(prevIndex);
    setModalItem(filteredData[prevIndex]);
  };

  const getLocalized = (item, field) => {
    const lang = i18n.language;
    if (lang === "gu") return item[`${field}_GJ`] || item[field];
    if (lang === "hi") return item[`${field}_HN`] || item[field];
    if (lang === "en") return item[`${field}_EN`] || item[field];
    return item[field];
  };

  const convertToEmbedUrl = (url) => {
    if (url.includes("youtube.com/watch?v=")) {
      return url.replace("watch?v=", "embed/");
    }
    if (url.includes("youtube.com/shorts/")) {
      return url.replace("youtube.com/shorts/", "youtube.com/embed/");
    }
    if (url.includes("youtu.be/")) {
      return url.replace("youtu.be/", "youtube.com/embed/");
    }
    return url;
  };

  const renderVideo = (item) => (
    <div
      key={item.albumMediaID}
      className="col-12 col-md-6 mb-4 cursor-pointer"
      onClick={() => handleShow_Album(item)}
    >
      <div className="ratio ratio-16x9">
        {item.videoTypeID === 2 ? (
          <iframe
            src={convertToEmbedUrl(item.mediaPath)}
            title={getLocalized(item, "mediaTitle")}
            allowFullScreen
          ></iframe>
        ) : (
          <video controls>
            <source src={pathUrl + item.mediaPath} type="video/mp4" />
            {t("Your browser does not support the video tag.")}
          </video>
        )}
      </div>
      <h5 className="mt-2 fs-6 text-[#4c934c] text-center">
        {getLocalized(item, "mediaTitle")}
      </h5>
    </div>
  );

  return (
    <>
      {/* Breadcrumb */}
      <div className="container mb-15 px-12 h-10px">
        <div
          className="ms-1 row mb-4 col-lg-12 col-md-12 col-sm-12 bg-light shadow mt-product bdr-1 bdr-solid bdr-gray-light"
          style={{ height: "50px" }}
        >
          <NavLink
            to="/page/gallery&album"
            className="site-button"
            style={{ fontSize: "17px", color: "#000000", marginTop: "7px" }}
          >
            {t("gallery_page.title")} {" >> "}
            <span className="text-[#4c934c]" style={{ fontSize: "17px" }}>
              {title}
            </span>
          </NavLink>
        </div>
      </div>

      {/* Title */}
      <div className="w-full text-center mb-4">
        <h3
          style={{
            fontSize: "2.3rem",
            color: "#4c934c",
            letterSpacing: "0.1rem",
          }}
        >
          {title}
          <div className="w-16 h-1 bg-[#4c934c] mx-auto mt-2" />
        </h3>
      </div>

      {/* Tabs */}
      <div className="container py-1">
        <div className="d-flex justify-content-center mb-4 gap-3 border-bottom pb-2">
          {[
            { key: "photo", label: t("tab_photo") },
            { key: "video", label: t("tab_video") },
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => handleTabChange(tab.key)}
              className={`btn ${
                activeTab === tab.key
                  ? "btn-warning bg-[#4c934c]"
                  : "btn-outline-secondary"
              } text-capitalize`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Content */}
        {loading ? (
          <p className="text-center">Loading {activeTab}s...</p>
        ) : activeTab === "photo" ? (
          <div className="row">
            {filteredData.length > 0 ? (
              filteredData.map((item) => (
                <div
                  key={item.albumMediaID}
                  className="col-12 col-sm-6 col-md-4 col-lg-4 mb-4"
                  onClick={() => handleShow_Album(item)}
                >
                  <div className="card h-200 shadow-sm cursor-pointer">
                    <img
                      src={
                        pathUrl + item.mediaPath || "/assets/img/no-image.jpg"
                      }
                      alt={getLocalized(item, "mediaTitle")}
                      className="card-img-top img-fluid"
                      style={{ height: "280px", objectFit: "cover" }}
                    />
                    <div className="card-body fs-6 text-[#4c934c] text-center">
                      <p className="card-title mb-0">
                        {getLocalized(item, "mediaTitle")}
                      </p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div
                className="col-12 d-flex flex-column justify-content-center align-items-center text-center"
                style={{ minHeight: "80px" }}
              >
                <p className="fs-6 text-muted">{t("no_data")}</p>
                <img
                  src="/assets/logo/15-dark.png"
                  alt={t("no_data")}
                  width={55}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="row g-4">
            {filteredData.length > 0 ? (
              filteredData.map((item) => renderVideo(item))
            ) : (
              <div
                className="col-12 d-flex flex-column justify-content-center align-items-center text-center"
                style={{ minHeight: "80px" }}
              >
                <p className="fs-6 text-muted">{t("no_data")}</p>
                <img
                  src="/assets/logo/15-dark.png"
                  alt={t("no_data")}
                  width={55}
                />
              </div>
            )}
          </div>
        )}
      </div>

      {/* Modal */}
      {showAlbum && modalItem && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.8)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content position-relative">
              <div className="modal-header">
                <h5 className="modal-title fs-4">
                  <span className="text-dark fs-5 mx-2">{title}</span>
                  <span className="text-[#4c934c] fs-5">
                    {getLocalized(modalItem, "mediaTitle")}
                  </span>
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose_Album}
                ></button>
              </div>
              <div
                className="modal-body d-flex justify-content-center align-items-center position-relative"
                style={{ maxHeight: "90vh" }}
              >
                {modalItem.mediaTypeID === 1 ? (
                  <img
                    src={pathUrl + modalItem.mediaPath}
                    alt={getLocalized(modalItem, "mediaTitle")}
                    className="img-fluid rounded"
                    style={{ maxHeight: "85vh", objectFit: "contain" }}
                  />
                ) : modalItem.videoTypeID === 2 ? (
                  <div className="ratio ratio-16x9">
                    <iframe
                      src={convertToEmbedUrl(modalItem.mediaPath)}
                      title={getLocalized(modalItem, "mediaTitle")}
                      allowFullScreen
                    ></iframe>
                  </div>
                ) : (
                  <video controls className="w-100">
                    <source
                      src={pathUrl + modalItem.mediaPath}
                      type="video/mp4"
                    />
                    {t("Your browser does not support the video tag.")}
                  </video>
                )}

                {/* Navigation Buttons */}
                <button
                  className="btn btn-secondary bg-[#4c934c] ms-2 position-absolute top-50 start-0 translate-middle-y"
                  onClick={handlePrev}
                >
                  ← Prev
                </button>
                <button
                  className="btn btn-secondary bg-[#4c934c] mx-2 position-absolute top-50 end-0 translate-middle-y"
                  onClick={handleNext}
                >
                  Next →
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <ElementPage />
    </>
  );
};

export default PhotoAndVideoListPage;
